
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const usePasswordManagement = (
  setIsLoading: (loading: boolean) => void,
  setAuthError: (error: string | null) => void
) => {
  const resetPassword = async (email: string): Promise<boolean> => {
    setIsLoading(true);
    setAuthError(null);
    
    try {
      const origin = window.location.origin;
      const redirectTo = `${origin}/reset-password`;
      
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo,
      });
      
      if (error) throw error;
      
      toast.success("Återställningsinstruktioner har skickats till din e-post.");
      return true;
    } catch (error: any) {
      console.error("Password reset error:", error);
      setAuthError(error.message || "Kunde inte skicka återställningsmail.");
      toast.error(error.message || "Kunde inte skicka återställningsmail.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const updatePassword = async (newPassword: string): Promise<boolean> => {
    setIsLoading(true);
    setAuthError(null);
    
    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });
      
      if (error) throw error;
      
      toast.success("Lösenordet har uppdaterats!");
      return true;
    } catch (error: any) {
      console.error("Password update error:", error);
      setAuthError(error.message || "Kunde inte uppdatera lösenordet.");
      toast.error(error.message || "Kunde inte uppdatera lösenordet.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { resetPassword, updatePassword };
};
